var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4826_5089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19234 5.09759C6.28093 4.83605 6.56478 4.69584 6.82632 4.78444C7.08787 4.87303 7.22807 5.15688 7.13947 5.41842C6.85208 6.26686 6.03696 6.82309 5.13759 6.82309C4.86145 6.82309 4.63759 6.59923 4.63759 6.32309C4.63759 6.04695 4.86145 5.82309 5.13759 5.82309C5.63059 5.82309 6.04948 5.51934 6.19234 5.09759Z",
    fill: "#C497FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22299 2.85105C6.09684 0.161631 9.90164 0.161631 10.7755 2.85105C11.0324 3.64177 11.7693 4.17712 12.6007 4.17712C15.4285 4.17712 16.6042 7.79571 14.3165 9.45786C13.6439 9.94655 13.3624 10.8128 13.6193 11.6035C14.4932 14.2929 11.415 16.5293 9.12727 14.8672C8.45464 14.3785 7.54384 14.3785 6.87121 14.8672C4.58346 16.5293 1.50531 14.2929 2.37915 11.6035C2.63607 10.8128 2.35462 9.94655 1.68199 9.45786C-0.605764 7.79571 0.569985 4.17712 3.3978 4.17712C4.22922 4.17712 4.96607 3.64177 5.22299 2.85105ZM9.82443 3.16006C9.24994 1.39196 6.74854 1.39196 6.17405 3.16006C5.78326 4.36281 4.66244 5.17712 3.3978 5.17712C1.53871 5.17712 0.765736 7.55609 2.26977 8.64884C3.29289 9.39218 3.721 10.7098 3.33021 11.9125C2.75572 13.6806 4.77939 15.1509 6.28343 14.0582C7.30654 13.3148 8.69194 13.3148 9.71505 14.0582C11.2191 15.1509 13.2428 13.6806 12.6683 11.9125C12.2775 10.7098 12.7056 9.39218 13.7287 8.64884C15.2327 7.55609 14.4598 5.17712 12.6007 5.17712C11.336 5.17712 10.2152 4.36281 9.82443 3.16006Z",
    fill: "#C497FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4826_5089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star_empty.e8e7764466fbaa251a9948c6e1654902.svg";
export { ForwardRef as ReactComponent };